import { Color } from "config/colors";
import { FontFamily, FontSize } from "config/font";
import styled from "styled-components";

type FontProps = {
  color?: Color;
  fontSize?: FontSize;
  backgroundColor?: Color;
  fontFamily?: FontFamily;
  padding?: boolean;
  align?: "center" | "left" | "right";
  ontSize?: FontSize;
  marginLeft?: number;
  alignSelf?:
    | "auto"
    | "flex-start"
    | "flex-end"
    | "center"
    | "baseline"
    | "stretch";
};

export const LabelStyled = styled.span<{
  color?: Color;
  fontFamily?: FontFamily;
  fontSize?: FontSize;
}>`
  color: ${(props) => (props.color ? props.color : Color.SeaBlue600)};
  font-family: ${(props) =>
      props.fontFamily ? props.fontFamily : FontFamily.MontserratSemiBold},
    Helvetica;
  font-size: ${(props) =>
    props.fontSize ? props.fontSize : FontSize.Standard};
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 200px;
  width: 100%;

  @media (max-width: 768px) {
    padding-bottom: 120px;
    padding-left: 16px;
    padding-right: 16px;
  }

  @media (max-width: 480px) {
    padding-bottom: 80px;
    padding-left: 12px;
    padding-right: 12px;
  }
`;

export const FormStyled = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media (max-width: 480px) {
    align-items: center;
  }
`;

export const TextInput = styled.input<FontProps>`
  width: 460px;
  padding: 5px;
  font-size: ${FontSize.H3};
  color: ${Color.White};
  font-family: ${FontFamily.MontserratRegular}, Helvetica;
  background-color: ${Color.MidnightBlue};
  border-radius: 20px;
  height: 100px;
  padding-left: 20px;
  margin-left: 70px;

  &::placeholder {
    color: ${Color.White};
  }
`;

export const CompanyNameContainer = styled.div`
  text-align: right;
  margin-top: 100px;
  width: 100%;
  p {
    margin-right: 100px;
  }
  @media (max-width: 912px) {
    p {
      text-align: center;
      font-size: 18px;
    }
  }
`;

export const InputContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  align-self: flex-start;
  margin-left: 0;
  margin-right: auto;
  margin-bottom: 12px;
  max-width: 535px;

  @media (max-width: 768px) {
    padding-right: 16px;
    padding-left: 0;
    margin-bottom: 10px;
  }

  @media (max-width: 480px) {
    padding-right: 12px;
    padding-left: 0;
    margin-bottom: 8px;
  }

  > input {
    width: 100%;
    height: 60px;
    padding: 0 16px;
    border: none;
    outline: none;
    border-radius: 16px;
    font-size: 28px;
    box-sizing: border-box;
    height: 80px;
    margin-top: 60px;

    @media (max-width: 768px) {
      height: 56px;
      font-size: 20px;
      margin-top: 0px;
    }
    @media (max-width: 480px) {
      height: 54px;
      font-size: 20px;
      margin-left: 40px;
      margin-right: 31px;
    }
  }
`;

export const InfoContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-left: 70px;
  margin-right: 100px;

  @media (max-width: 912px) {
    flex-wrap: wrap;
    margin-top: 50px;
    margin-bottom: 0px;
    p {
      margin-bottom: 0px;
    }
    h1 {
      margin-left: 0px;
    }
  }
`;

export const DayInfoContainer = styled.div`
  margin-top: 100px;
  margin-right: 0px;
  display: flex;
  flex-direction: column;
  p {
    margin-bottom: 0px;
  }
  @media (max-width: 912px) {
    margin-top: 0px;
    flex-direction: row;
    width: 100%;

    p {
      font-size: 18px;
      margin-bottom: 40px;
      margin-right: 20px;
    }
  }
`;

export const Text = styled.p<FontProps>`
  color: ${(props) => (props.color ? props.color : Color.MidnightBlue)};
  font-size: ${(props) =>
    props.fontSize ? props.fontSize : FontSize.Standard};
  font-family: ${(props) =>
      props.fontFamily ? props.fontFamily : FontFamily.MontserratRegular},
    Helvetica;
  text-decoration: none;
  background-color: ${(props) =>
    props.backgroundColor ? props.backgroundColor : "none"};
  ${(props) => props.padding && "padding: 5px; border-radius: 4px;"}
  ${(props) => props.align && `text-align: ${props.align};`}
  align-self: ${(props) => (props.alignSelf ? props.alignSelf : "none")};
  margin-left: ${(props) => (props.marginLeft ? `${props.marginLeft}px` : 0)};
`;

export const CheckInOutModal = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 370px;
  background-color: ${Color.White};
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  outline: none;
  border-radius: 8px;
  button {
    font-size: ${FontSize.Small};
  }
  p {
    margin: 0 0 30px 0;
  }
  div {
  }
`;

export const ClockStampCreateAutoGeneratedGigBody = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 500px;
  background-color: ${Color.White};
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  outline: none;
  border-radius: 8px;
  button {
    font-size: ${FontSize.Small};
  }
  p {
    margin: 0 0 30px 0;
  }
  @media (max-width: 480px) {
    width: 370px;
  }
`;

export const ButtonContainer = styled.div`
  display: grid;
  grid-template: 1fr / 1fr 1fr;
  width: fit-content;
  margin: auto;
  margin-top: 20px;

  button {
    margin: 0 10px;
    width: 150px;
    height: 50px;
    font-size: ${FontSize.H4};
  }
`;

export const CheckInChooseTimeModal = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 600px;
  height: 400px;
  background-color: ${Color.White};
  padding: 40px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  outline: none;
  border-radius: 8px;
  p {
    margin: 0 0 30px 0;
  }
  button {
    height: 100px;
    font-size: ${FontSize.H4};
  }
  @media (max-width: 480px) {
    width: 370px;
  }
`;

export const GigInfoContainer = styled.div`
  background-color: ${Color.Positive};
  border-radius: 8px;
  padding: 20px;
`;

export const TimeReportModal = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 470px;
  max-height: 90vh;
  max-width: 90vh;
  background-color: ${Color.White};
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  outline: none;
  border-radius: 8px;
  button {
    font-size: ${FontSize.Small};
  }
  p {
    margin: 0 0 30px 0;
  }
  div {
  }
  overflow-y: scroll;
  overflow-x: scroll;

  @media (max-width: 480px) {
    width: 370px;
  }
`;

export const Row = styled.div`
  background-color: ${Color.White};
  margin: 10px 0;
  padding: 10px;
  display: grid;
  grid-row-gap: 10px;
  grid-column-gap: 20px;
  grid-template:
    "container1 container2 container3"
    / 1fr auto;

  border-bottom: 1px solid ${Color.SeaBlue200};

  @media (min-width: 640px) {
    grid-template:
      "container1 container2 container3" auto
      / 1fr auto;
  }

  @media (min-width: 970px) {
    grid-template:
      "container1 container2 container3" auto
      / 2fr 2fr 2fr auto;
  }

  p {
    margin: 0;
  }
`;

export const Container1 = styled.div`
  grid-name: container1;
  display: flex;
  flex-direction: row;
`;

export const Container2 = styled.div`
  grid-name: container2;
  display: flex;
  flex-direction: row;
`;

export const Container3 = styled.div`
  grid-name: container3;
  display: flex;
  flex-direction: row;
`;
